import LoadingSwitcher from "../../../general/loading/LoadingSwitcher";
import Calendar from "../../../general/calendar/Calendar";
import DateUtil from "../../../general/calendar/dateUtil";
import useCheckoutStore from "../../../../cart/store/checkoutStore";
import useDeliveryDates from "../../../../services/state/delivery/useDeliveryDates";
import useSession from "../../../../services/state/session/useSession";

const maxDate = new Date();
maxDate.setDate(maxDate.getDate() + 60);

const DeliveryDateSelection = ({ deliveryVia, justTheDates, datePromised }) => {

    // const datePromised = checkout.getDatePromised();

    const session = useSession();
    const typeText = deliveryVia === 'D' ? "Delivery" : "Collection";
    const setDatePromised = useCheckoutStore(state => state.setDeliveryDate);
    const onDatePromisedChanged = (date) => setDatePromised(session, date);

    if(justTheDates?.length > 0) {
        return (
            <>
                <p className="cart-h">Please select {typeText} date</p>
                <Calendar
                    maxDate={justTheDates[justTheDates.length - 1]}
                    minDate={justTheDates[0]}
                    whiteList={justTheDates}
                    selectedDate={datePromised}
                    onDateClick={onDatePromisedChanged}
                />
            </>
        )
    }
}

const DeliveryDateDisplay = ({ deliveryVia, datePromised }) => {

    const clearIt = useCheckoutStore(state => state.clearInput);
    const toUse = typeof datePromised === 'string' ? new Date(datePromised) : datePromised;
    const text = (deliveryVia === 'D' ? "Delivery on " : "Collecting on ") + DateUtil.getDisplayDate(toUse);

    return (
        <div className="cart-info-split">
            <p className="cart-h">{text}</p>
            <p className="clickable-text" onClick={() => clearIt('deliveryDate')}>Change</p>
        </div>
    )

}

const DeliveryWarning = ({ deliveryVia, showWarning }) => {

    const msg = deliveryVia === 'D'
        ? 'Cannot deliver to this address'
        : 'Something has gone wrong, no collection dates could be found';

    if(showWarning)
        return <p className="cart-warning">{msg}</p>
}

const CartDeliveryDate = () => {

    const session = useSession();
    const bPartnerLocationID = useCheckoutStore(state => state.order?.C_BPartner_Location_ID?.id)
    const deliveryVia = useCheckoutStore(state => state.order?.DeliveryViaRule?.id);
    const datePromised = useCheckoutStore(state => state.input?.deliveryDate);
    const {
        loading, availableDates
    } = useDeliveryDates({
        bPartnerID: session.sessionData.bPartnerID,
        bPartnerLocationID: bPartnerLocationID,
        autoLoad:true,
        forPickUp: deliveryVia === 'P'
    });

    const justTheDates = availableDates?.map(e => new Date(e.available_date));
    const showWarning = (!justTheDates || justTheDates.length === 0);

    return (
        <div className="cart-sub-section">
            <LoadingSwitcher loading={loading}>
                <DeliveryWarning showWarning={showWarning} deliveryVia={deliveryVia} />
                {!showWarning &&
                    <>
                        {!datePromised ?
                            <DeliveryDateSelection
                                deliveryVia={deliveryVia}
                                justTheDates={justTheDates}
                                datePromised={datePromised}
                            /> :
                            <DeliveryDateDisplay
                                deliveryVia={deliveryVia}
                                datePromised={datePromised}
                            />
                        }
                    </>
                }
            </LoadingSwitcher>
        </div>
    )
}

export default CartDeliveryDate;
